import { createAction } from '@reduxjs/toolkit';
import {
  ScorecardCommentThread,
  ScorecardsActionStoreArgument,
} from 'store/interfaces';

export const updateScorecardCommentsThread = createAction<{
  store: ScorecardsActionStoreArgument;
  scorecardId: number;
  goalId: number;
  subgoalId?: number;
  thread: ScorecardCommentThread;
  change?: number;
}>('scorecards/updateScorecardCommentsThread');
